export default __webpack_public_path__ + "static/process-05-2b1d507cbc1ee915af2b3c7bed409377.svg";